import * as React from "react";
import { Navigate } from "react-router-dom";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";
import { Copyright } from "../components/Copyright";
import "../assets/styles/styles.css";
import "../assets/styles/animations.css";
import { AlertPosition, AlertType, CopyrightType } from "../assets/enums";
import { HeadingLogo } from "../components";
import ActionAlerts from "../ui/Alerts";
import { useAppDispatch } from "../hooks";
import { ResetPassword, SignIn } from "../stores";

export const ResetPasswordPage = () => {
  if (
    sessionStorage.getItem("token") &&
    sessionStorage.getItem("token") !== "undefined"
  )
    return <Navigate to="/panel" />;

  const [displayErrorAlert, setIsDisplayAlert] = React.useState<boolean>(false);

  const dispatch = useAppDispatch();

  const showAlert = () => {
    setIsDisplayAlert(true);
    setTimeout(() => {
      setIsDisplayAlert(false);
    }, 5000);
  };

  const closeAlert = () => {
    setIsDisplayAlert(false);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const formData = {
      email: data.get("email") as string,
    };

    try {
      const payload = await dispatch(ResetPassword({ email: formData.email }));
      showAlert();
    } catch (error: any) {
      return;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {displayErrorAlert && (
        <ActionAlerts
          alertDisplayStatus={true}
          alertPosition={AlertPosition.Fixed}
          alertType={AlertType.Error}
          alertTitle="Potwierdzenie resetu hasła"
          alertText="Link do resetu hasła został wysłany na e-mail podany w formularzu. Aby dokończyć zmianę hasła postępuj zgodnie z instrukcją w e-mailu."
          setStateOfAlert={closeAlert}
        />
      )}
      <Container className="fadeIn" component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "100vh",
            justifyContent: "center",
          }}
        >
          <HeadingLogo />

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 2 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="text"
              label="Wpisz swój e-mail"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="Nazwa firmy"
              label="Nazwa firmy"
              type="text"
              id="company"
              autoComplete="company"
            />
            <Grid container justifyContent="center">
              <Grid item>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  sx={{ mt: 3, mb: 3 }}
                  className="hover-button-color"
                >
                  Resetuj hasło
                </Button>
              </Grid>
            </Grid>
            <Grid container justifyContent="center">
              <Grid item>
                Nie posiadasz konta?
                <Link href="/rejestracja" variant="body2">
                  {" Załóż je!"}
                </Link>
              </Grid>
              <Grid item>
                Posiadasz konto?
                <Link href="/" variant="body2">
                  {" Zaloguj się!"}
                </Link>
              </Grid>
            </Grid>
          </Box>
          <Copyright type={CopyrightType.Form} />
        </Box>
      </Container>
    </ThemeProvider>
  );
};
